import { render, staticRenderFns } from "./primerFinder.vue?vue&type=template&id=1136218e&"
import script from "./primerFinder.vue?vue&type=script&lang=js&"
export * from "./primerFinder.vue?vue&type=script&lang=js&"
import style0 from "./primerFinder.vue?vue&type=style&index=0&id=1136218e&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports